import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=4299b845"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4299b845')) {
      api.createRecord('4299b845', component.options)
    } else {
      api.reload('4299b845', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=4299b845", function () {
      api.rerender('4299b845', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/s/Icon.vue"
export default component.exports